export enum AccessibilityType {
  LIVE_ATTENDANCE = 'LIVE_ATTENDANCE',
  STREAMING = 'STREAMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/accessibility-type.ts